// 自動生成 = scripts/render_parry_remake.py (手で直さない・直したら素材と一緒に書き出し直す)。
// 案 (a|b|c) → 材質 → 技の重さ w の格子ごとの「芯」と「重さの層」の速さ・倍率。ゲームは w の前後2点を直線でつなぐ。
// 倍率は今の柳の型の gainDb (-8) を掛ける前・relDb = 柳の型を 0dB とした大きさ (そろえた値)。
export const PARRY_REMAKE_PLAN = {
 "refM400": -14.0,
 "grid": [
  0.0,
  0.25,
  0.5,
  0.75,
  1.0
 ],
 "variants": {
  "a": {
   "blade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9045,
     "weightRate": 1.12,
     "weightGain": 0.3166,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8748,
     "weightRate": 1.055,
     "weightGain": 0.4483,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8147,
     "weightRate": 0.99,
     "weightGain": 0.5499,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7932,
     "weightRate": 0.925,
     "weightGain": 0.6643,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7538,
     "weightRate": 0.86,
     "weightGain": 0.7538,
     "relDb": 0.3
    }
   ],
   "greatblade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.0262,
     "weightRate": 1.12,
     "weightGain": 0.3592,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9776,
     "weightRate": 1.055,
     "weightGain": 0.501,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8971,
     "weightRate": 0.99,
     "weightGain": 0.6056,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8767,
     "weightRate": 0.925,
     "weightGain": 0.7343,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8352,
     "weightRate": 0.86,
     "weightGain": 0.8352,
     "relDb": 0.3
    }
   ],
   "lance": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9832,
     "weightRate": 1.12,
     "weightGain": 0.3441,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9497,
     "weightRate": 1.055,
     "weightGain": 0.4867,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8907,
     "weightRate": 0.99,
     "weightGain": 0.6012,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8591,
     "weightRate": 0.925,
     "weightGain": 0.7195,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8051,
     "weightRate": 0.86,
     "weightGain": 0.8051,
     "relDb": 0.3
    }
   ],
   "haft": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.098,
     "weightRate": 1.12,
     "weightGain": 0.3843,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 1.0625,
     "weightRate": 1.055,
     "weightGain": 0.5445,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.9755,
     "weightRate": 0.99,
     "weightGain": 0.6584,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.9249,
     "weightRate": 0.925,
     "weightGain": 0.7746,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8702,
     "weightRate": 0.86,
     "weightGain": 0.8702,
     "relDb": 0.3
    }
   ],
   "claw": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.0203,
     "weightRate": 1.12,
     "weightGain": 0.3571,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9912,
     "weightRate": 1.055,
     "weightGain": 0.508,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.9243,
     "weightRate": 0.99,
     "weightGain": 0.6239,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8822,
     "weightRate": 0.925,
     "weightGain": 0.7388,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8249,
     "weightRate": 0.86,
     "weightGain": 0.8249,
     "relDb": 0.3
    }
   ],
   "iron": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9565,
     "weightRate": 1.12,
     "weightGain": 0.3348,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9173,
     "weightRate": 1.055,
     "weightGain": 0.4701,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8437,
     "weightRate": 0.99,
     "weightGain": 0.5695,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8204,
     "weightRate": 0.925,
     "weightGain": 0.6871,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7828,
     "weightRate": 0.86,
     "weightGain": 0.7828,
     "relDb": 0.3
    }
   ],
   "veil": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.0087,
     "weightRate": 1.12,
     "weightGain": 0.3531,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.963,
     "weightRate": 1.055,
     "weightGain": 0.4935,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8965,
     "weightRate": 0.99,
     "weightGain": 0.6051,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8601,
     "weightRate": 0.925,
     "weightGain": 0.7203,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8124,
     "weightRate": 0.86,
     "weightGain": 0.8124,
     "relDb": 0.3
    }
   ],
   "shell": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9327,
     "weightRate": 1.12,
     "weightGain": 0.3264,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8966,
     "weightRate": 1.055,
     "weightGain": 0.4595,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.817,
     "weightRate": 0.99,
     "weightGain": 0.5514,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8028,
     "weightRate": 0.925,
     "weightGain": 0.6723,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7721,
     "weightRate": 0.86,
     "weightGain": 0.7721,
     "relDb": 0.3
    }
   ]
  },
  "b": {
   "blade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8874,
     "weightRate": 1.12,
     "weightGain": 0.2662,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8575,
     "weightRate": 1.055,
     "weightGain": 0.4073,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.7965,
     "weightRate": 0.99,
     "weightGain": 0.5177,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7708,
     "weightRate": 0.925,
     "weightGain": 0.6359,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.728,
     "weightRate": 0.86,
     "weightGain": 0.728,
     "relDb": 0.3
    }
   ],
   "greatblade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.939,
     "weightRate": 1.12,
     "weightGain": 0.2817,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.904,
     "weightRate": 1.055,
     "weightGain": 0.4294,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8361,
     "weightRate": 0.99,
     "weightGain": 0.5435,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8167,
     "weightRate": 0.925,
     "weightGain": 0.6738,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7781,
     "weightRate": 0.86,
     "weightGain": 0.7781,
     "relDb": 0.3
    }
   ],
   "lance": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9684,
     "weightRate": 1.12,
     "weightGain": 0.2905,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9341,
     "weightRate": 1.055,
     "weightGain": 0.4437,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8719,
     "weightRate": 0.99,
     "weightGain": 0.5667,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8369,
     "weightRate": 0.925,
     "weightGain": 0.6905,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7804,
     "weightRate": 0.86,
     "weightGain": 0.7804,
     "relDb": 0.3
    }
   ],
   "haft": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.0887,
     "weightRate": 1.12,
     "weightGain": 0.3266,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 1.0586,
     "weightRate": 1.055,
     "weightGain": 0.5028,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.9718,
     "weightRate": 0.99,
     "weightGain": 0.6316,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.9176,
     "weightRate": 0.925,
     "weightGain": 0.757,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8569,
     "weightRate": 0.86,
     "weightGain": 0.8569,
     "relDb": 0.3
    }
   ],
   "claw": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.04,
     "weightRate": 1.12,
     "weightGain": 0.312,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 1.0013,
     "weightRate": 1.055,
     "weightGain": 0.4756,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.9295,
     "weightRate": 0.99,
     "weightGain": 0.6042,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8789,
     "weightRate": 0.925,
     "weightGain": 0.7251,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8157,
     "weightRate": 0.86,
     "weightGain": 0.8157,
     "relDb": 0.3
    }
   ],
   "iron": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9129,
     "weightRate": 1.12,
     "weightGain": 0.2739,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8814,
     "weightRate": 1.055,
     "weightGain": 0.4187,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.814,
     "weightRate": 0.99,
     "weightGain": 0.5291,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7928,
     "weightRate": 0.925,
     "weightGain": 0.654,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7555,
     "weightRate": 0.86,
     "weightGain": 0.7555,
     "relDb": 0.3
    }
   ],
   "veil": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 1.0147,
     "weightRate": 1.12,
     "weightGain": 0.3044,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9662,
     "weightRate": 1.055,
     "weightGain": 0.4589,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.892,
     "weightRate": 0.99,
     "weightGain": 0.5798,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8483,
     "weightRate": 0.925,
     "weightGain": 0.6999,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7955,
     "weightRate": 0.86,
     "weightGain": 0.7955,
     "relDb": 0.3
    }
   ],
   "shell": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9875,
     "weightRate": 1.12,
     "weightGain": 0.2962,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9454,
     "weightRate": 1.055,
     "weightGain": 0.449,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8543,
     "weightRate": 0.99,
     "weightGain": 0.5553,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8264,
     "weightRate": 0.925,
     "weightGain": 0.6818,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7808,
     "weightRate": 0.86,
     "weightGain": 0.7808,
     "relDb": 0.3
    }
   ]
  },
  "c": {
   "blade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8138,
     "weightRate": 1.12,
     "weightGain": 0.4476,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.7955,
     "weightRate": 1.055,
     "weightGain": 0.527,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.7602,
     "weightRate": 0.99,
     "weightGain": 0.5892,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7591,
     "weightRate": 0.925,
     "weightGain": 0.6737,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7456,
     "weightRate": 0.86,
     "weightGain": 0.7456,
     "relDb": 0.3
    }
   ],
   "greatblade": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8867,
     "weightRate": 1.12,
     "weightGain": 0.4877,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8647,
     "weightRate": 1.055,
     "weightGain": 0.5728,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8207,
     "weightRate": 0.99,
     "weightGain": 0.6361,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8206,
     "weightRate": 0.925,
     "weightGain": 0.7283,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7984,
     "weightRate": 0.86,
     "weightGain": 0.7984,
     "relDb": 0.3
    }
   ],
   "lance": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8616,
     "weightRate": 1.12,
     "weightGain": 0.4739,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8407,
     "weightRate": 1.055,
     "weightGain": 0.557,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8026,
     "weightRate": 0.99,
     "weightGain": 0.622,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7988,
     "weightRate": 0.925,
     "weightGain": 0.709,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7803,
     "weightRate": 0.86,
     "weightGain": 0.7803,
     "relDb": 0.3
    }
   ],
   "haft": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.9485,
     "weightRate": 1.12,
     "weightGain": 0.5217,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.9197,
     "weightRate": 1.055,
     "weightGain": 0.6093,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8768,
     "weightRate": 0.99,
     "weightGain": 0.6795,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8594,
     "weightRate": 0.925,
     "weightGain": 0.7627,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8335,
     "weightRate": 0.86,
     "weightGain": 0.8335,
     "relDb": 0.3
    }
   ],
   "claw": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8641,
     "weightRate": 1.12,
     "weightGain": 0.4753,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8423,
     "weightRate": 1.055,
     "weightGain": 0.558,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.804,
     "weightRate": 0.99,
     "weightGain": 0.6231,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8018,
     "weightRate": 0.925,
     "weightGain": 0.7116,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7868,
     "weightRate": 0.86,
     "weightGain": 0.7868,
     "relDb": 0.3
    }
   ],
   "iron": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8352,
     "weightRate": 1.12,
     "weightGain": 0.4593,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8181,
     "weightRate": 1.055,
     "weightGain": 0.542,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.7766,
     "weightRate": 0.99,
     "weightGain": 0.6019,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7723,
     "weightRate": 0.925,
     "weightGain": 0.6854,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7554,
     "weightRate": 0.86,
     "weightGain": 0.7554,
     "relDb": 0.3
    }
   ],
   "veil": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8934,
     "weightRate": 1.12,
     "weightGain": 0.4914,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8689,
     "weightRate": 1.055,
     "weightGain": 0.5756,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.8309,
     "weightRate": 0.99,
     "weightGain": 0.644,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.8232,
     "weightRate": 0.925,
     "weightGain": 0.7306,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.8038,
     "weightRate": 0.86,
     "weightGain": 0.8038,
     "relDb": 0.3
    }
   ],
   "shell": [
    {
     "w": 0.0,
     "coreRate": 1.05,
     "coreGain": 0.8344,
     "weightRate": 1.12,
     "weightGain": 0.4589,
     "relDb": -1.2
    },
    {
     "w": 0.25,
     "coreRate": 1.025,
     "coreGain": 0.8208,
     "weightRate": 1.055,
     "weightGain": 0.5438,
     "relDb": -0.82
    },
    {
     "w": 0.5,
     "coreRate": 1.0,
     "coreGain": 0.7793,
     "weightRate": 0.99,
     "weightGain": 0.6039,
     "relDb": -0.45
    },
    {
     "w": 0.75,
     "coreRate": 0.975,
     "coreGain": 0.7831,
     "weightRate": 0.925,
     "weightGain": 0.695,
     "relDb": -0.07
    },
    {
     "w": 1.0,
     "coreRate": 0.95,
     "coreGain": 0.7632,
     "weightRate": 0.86,
     "weightGain": 0.7632,
     "relDb": 0.3
    }
   ]
  }
 }
} as const
